module.exports = __webpack_public_path__ + "img/about2.7febc11a.jpg";